/* IMPORT */
import GRAPHVIZ_BASE64 from '../graphviz/graphviz.js';
import generate from './generate.js';
/* MAIN */
const Graphviz = generate(GRAPHVIZ_BASE64);
/* EXPORT */
export default Graphviz;
